import { useLingui } from "@lingui/macro";

import { cn } from "@app/lib/utils";

/**
 * A count read in aggregate that falls under the anonymity threshold (PT-144). The API sends `null`
 * for it, and the page says so rather than printing « 0 »: a handful of a colleague's patients is a
 * handful of people.
 */
export function WithheldCount({ className }: { className?: string }) {
  const { t } = useLingui();
  return (
    <span title={t`Effectif inférieur au seuil d'anonymat, masqué`} className={cn("cursor-help", className)}>
      {t`< seuil`}
    </span>
  );
}
